
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.69 66.78a2.52 2.52 0 01-2.17-1.25 2.49 2.49 0 01.92-3.41L77.78 21.5a2.5 2.5 0 112.5 4.33L9.94 66.45a2.6 2.6 0 01-1.25.33z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    